import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { isOnboardingTourActive } from '@/lib/onboardingTour';

interface OnboardingGateProps {
  children: React.ReactNode;
}

export const OnboardingGate: React.FC<OnboardingGateProps> = ({ children }) => {
  const location = useLocation();
  const user = useAuthStore((state) => state.user);

  const needsOnboarding =
    user?.onboarding_completed === false && user?.onboarding_dismissed !== true;
  const tourIsActive = isOnboardingTourActive();

  if (needsOnboarding && !tourIsActive && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default OnboardingGate;
